import { render, staticRenderFns } from "./ManufacturerOrganizations.vue?vue&type=template&id=0ffbc9a8&scoped=true&"
import script from "./ManufacturerOrganizations.vue?vue&type=script&lang=js&"
export * from "./ManufacturerOrganizations.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturerOrganizations.vue?vue&type=style&index=0&id=0ffbc9a8&scoped=true&lang=css&"
import style1 from "./ManufacturerOrganizations.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffbc9a8",
  null
  
)

export default component.exports